import React, { memo } from 'react';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { InputFieldProps, InputNew } from 'components/Forms';
import InputFieldWrapper from 'components/Forms/InputFieldWrapper';
import { DATE_WITH_SLASH_FORMAT } from 'constants/dates';
import LuxonUtils from '@date-io/luxon';
import { Settings } from 'luxon';
import { feedbackButtonZIndex } from 'styles/defaultTheme';
import { FieldInputProps, FieldMetaState } from 'react-final-form';

Settings.defaultLocale = 'en';

const TextFieldComponent = (props: any) => {
  const { dateNewField, dateNewMeta, dateNewInput, ...textFieldProps } = props;
  return (
    <InputNew
      {...textFieldProps}
      onBlur={dateNewInput.onBlur}
      field={dateNewField}
      meta={dateNewMeta}
      wrapField={false}
    />
  );
};

const DateNew = ({
  field,
  input,
  meta
}: {
  field: InputFieldProps;
  input: FieldInputProps<string, HTMLElement>;
  meta: FieldMetaState<string | number>;
}) => {
  return (
    <InputFieldWrapper className="dateNew" marginBottom={3}>
      <MuiPickersUtilsProvider utils={LuxonUtils}>
        <KeyboardDatePicker
          size="small"
          onChange={input.onChange}
          // Without this, it doesn't run validation when selecting a date from the calendar
          // without accessing the text input field
          onAccept={() => {
            input.onBlur();
          }}
          error={Boolean(meta.touched && meta.error)}
          placeholder={field.placeholder}
          // Passing an empty string (React Final Form default for empty values)
          // does not work with this date picker, it must be `null`
          value={input.value || null}
          // @ts-ignore
          dateNewField={field}
          dateNewMeta={meta}
          dateNewInput={input}
          TextFieldComponent={TextFieldComponent}
          format={input.format || DATE_WITH_SLASH_FORMAT}
          variant="inline"
          autoOk
          PopoverProps={{
            style: { zIndex: feedbackButtonZIndex + 1 }
          }}
        />
      </MuiPickersUtilsProvider>
    </InputFieldWrapper>
  );
};

export default memo(DateNew);
